var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('docs-wrapper',{attrs:{"link":"","is-homepage":false},scopedSlots:_vm._u([{key:"header-search-bar",fn:function(){return [_c('div',{staticClass:"docs-header-search-bar"},[_c('common-search-bar',{attrs:{"query-filter":"documentation","open-results-page":true}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }